// Fetch a proof-of-work challenge and solve it in a Web Worker. Returns the
// request fields the server expects, or {} when the server has the captcha
// disabled — the caller just spreads the result into its request body.

import { api } from './api'

type ChallengeResponse = {
  enabled: boolean
  challenge?: string
  difficulty?: number
  hmac?: string
}

export type CaptchaFields = {
  captcha_challenge?: string
  captcha_nonce?: string
  captcha_hmac?: string
}

export async function solveCaptcha(): Promise<CaptchaFields> {
  const issued = await api<ChallengeResponse>('/api/v1/captcha/challenge')
  if (!issued.enabled || !issued.challenge || !issued.hmac) return {}
  const worker = new Worker(new URL('./captchaWorker.ts', import.meta.url), { type: 'module' })
  try {
    const solved = await new Promise<{ nonce: string; challenge: string; hmac: string }>((resolve, reject) => {
      worker.onmessage = (event) => resolve(event.data)
      worker.onerror = (event) => reject(new Error(event.message || 'captcha solver failed'))
      worker.postMessage({ challenge: issued.challenge, difficulty: issued.difficulty ?? 18, hmac: issued.hmac })
    })
    return { captcha_challenge: solved.challenge, captcha_nonce: solved.nonce, captcha_hmac: solved.hmac }
  } finally {
    worker.terminate()
  }
}
